import _ from 'underscore';
import $ from 'jquery';

export default class OfferStocklistMassUpdateDialog {
  constructor($scope, $rootScope, $q, OfferService) {
    $scope.$on('show_mass_update_dialog', function(event, data) {
      window.openFancyboxDialog('div#offer_stocklist_mass_update_dialog');
      $scope.offers = _.sortBy(data.offers, 'id');
      $scope.updated_times = [];
      $scope.offers_length = $scope.offers.length;
      mass_update_stocklists();
    });

    $scope.steps = [
      {
        id: 1,
        title: 'Update Stocklists'
      }
    ];


    function update_offer(offer, index, deferred) {
      $scope.steps[0].progress = Math.ceil(((index + 1) / $scope.offers_length) * 100);
      var t0 = performance.now();

      OfferService.update_stocklist_from_parent(offer).then(function() {
        deferred.resolve();
        var t1 = performance.now();
        $scope.updated_times.push((t1 - t0)/1000);
      });
    }

    function update_offers() {
      return $scope.offers.reduce(function(promise, offer, index) {
        return promise.then(function() {
          var deferred = $q.defer();
          update_offer(offer.id, index, deferred);
          return deferred.promise;
        });
      }, $q.when());
    }

    function mass_update_stocklists() {
      _.each($scope.steps, function(step) {
        step.progress = 0;
        step.progress_started = true;
      });

      update_offers()
        .then(function() {
          $scope.updating_stocklists = false;
          $scope.load_offers();
          $.fancybox.close();
          OfferService.send_updated_offers_email(_.pluck($scope.offers, 'id'), $scope.updated_times);
        });
    }
  }
}

OfferStocklistMassUpdateDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-stocklist-mass-update-dialog.ctrl.js